module.exports = __webpack_public_path__ + "img/selectedOn.32125fa9.svg";